export default "__VITE_ASSET__C8ckI7Tj__"